<template>
  <div ref="chart" class="chart" style="width: 100%; height: 100%;"></div>
</template>

<script>
export default {
  name: "google-chart",
  props: {
    type: String,
    data: Object,
    extraOptions: {
      type: Object,
      default: () => ({}),
    },
    handleLabel: {
      type: Function,
      default: null,
    },
    colors: {
      type: Array,
      default: () => [
        "#4195cb",
        "#75ca7e",
        "#add674",
        "#e1e54d",
        "#fbb242",
        "#fb9318",
        "#f26533",
        "#8d373a",
        "#75ca7e",
        "#a1d9fe",
        "#c8e6c9",
      ],
    },
  },
  data: () => ({
    slices: {
      0: { textStyle: { color: "white", fontSize: 11 } },
      1: { textStyle: { color: "white", fontSize: 11 } },
      2: { textStyle: { color: "white", fontSize: 11 } },
      3: { textStyle: { color: "white", fontSize: 11 } },
      4: { textStyle: { color: "white", fontSize: 11 } },
      5: { textStyle: { color: "white", fontSize: 11 } },
      6: { textStyle: { color: "black", fontSize: 11 } },
      7: { textStyle: { color: "black", fontSize: 11 } },
      8: { textStyle: { color: "black", fontSize: 11 } },
      9: { textStyle: { color: "black", fontSize: 11 } },
    },
  }),
  mounted() {
    google.charts.load("current", { packages: ["corechart", "geochart"] });
    google.charts.setOnLoadCallback(() => {
      this.drawChart();
      window.addEventListener("resize", this.handleResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        this.drawChart();
      }, 300);
    },
    drawChart() {
      if (!this.data?.datasets?.length) return;

      const { data } = this.data.datasets[0];
      const list = [["", "QTTY"]];
      if (this.handleLabel) list[0].push({ type: "string", role: "tooltip" });

      for (let i = 0; i < data.length; i++) {
        const label = this.data.labels[i] || "OTHERS";
        const value = Number(data[i]);
        const element = [label, value];
        if (this.handleLabel) element.push(this.handleLabel(label, value));
        list.push(element);
      }

      const values = google.visualization.arrayToDataTable(list);

      const legendPosition = window.innerWidth < 1350 ? "bottom" : "right";

      const options = {
        pieHole: 0.6,
        chartArea: { width: "90%", height: "80%" },
        legend: {
          position: legendPosition,
          alignment: legendPosition === "bottom" ? "center" : "start",
          textStyle: { fontSize: 13 },
        },
        slices: this.slices,
        colors: this.colors,
        tooltip: { trigger: "hover" },
        ...this.extraOptions,
      };

      const chart = new google.visualization[this.type](this.$refs.chart);
      chart.draw(values, options);
    },
  },
};
</script>

<style scoped>
.chart {
  width: 100%;
  min-height: 350px;
  transition: all 0.3s ease;
}
</style>
